import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import * as React from 'react';
import { Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  list: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.background.default,
    },
    border: 'none',
    outline: 'none',
    lineHeight: '32px',
    paddingLeft: 12,
    display: 'flex',
    alignItems: 'center',
  },
  active: {
    backgroundColor: theme.palette.background.default,
    border: 'none',
    outline: 'none',
  },
}));

type Props = {
  active: boolean;
  onClick?: (arg0: string) => void;
  onMouseEnter?: (arg0: string) => void;
  onMouseLeave?: (arg0: string) => void;
  style?: React.CSSProperties;
  value: string;
  getLabel: (value: string) => string;
};

export default function Entry(props: Props) {
  const {
    onClick,
    value,
    active,
    style,
    onMouseLeave,
    onMouseEnter,
    getLabel,
  } = props;
  const handleClick = (e: React.SyntheticEvent<Element>) => {
    e.stopPropagation();

    if (onClick) {
      onClick(value);
    }
  };

  const handleMouseEnter = (e: React.SyntheticEvent<Element>) => {
    e.stopPropagation();

    if (onMouseEnter) {
      onMouseEnter(value);
    }
  };

  const handleMouseLeave = (e: React.SyntheticEvent<Element>) => {
    e.stopPropagation();

    if (onMouseLeave) {
      onMouseLeave(value);
    }
  };
  const classes = useStyles();
  const className = clsx(classes.list, active ? classes.active : null);
  const label = getLabel(value);
  return (
    <div
      className={className}
      onKeyDown={handleClick}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={style}
      role="button"
      tabIndex={0}
    >
      {label}
    </div>
  );
}
